// Datos legales del titular
export const TITULAR = {
  nombre: "Juan Guerrero Ramos",
  nif: "08837091P",
  direccion: "C/ Virgen de la Soledad, 26 — 06001 Badajoz",
  email: "artexsala@gmail.com",
  telefono: "656 813 536",
  web: "retratomascotas.es",
  nombre_comercial: "Retrato Mascotas",
};
